import React, { useState } from "react";
import PageLayout from '../components/PageLayout';
import PageHero from '../components/PageHero';
import { FaEnvelope, FaPhone, FaMapMarkerAlt } from 'react-icons/fa';
import { API_ENDPOINTS, submitForm } from '../config/api';

export default function ContactMe() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
    phoneNumber: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState({ type: '', message: '' });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleContactSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus({ type: '', message: '' });

    try {
      const { ok, data } = await submitForm(API_ENDPOINTS.CONTACT, {
        type: 'contact',
        ...formData,
      });

      if (ok) {
        setSubmitStatus({ type: 'success', message: 'Message sent successfully! We will get back to you soon.' });
        setFormData({
          name: '',
          email: '',
          message: '',
          phoneNumber: ''
        });
      } else {
        setSubmitStatus({ type: 'error', message: data.error || 'Failed to send message. Please try again.' });
      }
    } catch (error) {
      setSubmitStatus({ type: 'error', message: 'Something went wrong. Please try again.' });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <PageLayout>
      <PageHero
        eyebrow="Get in touch"
        title="Contact Us"
        subtitle="Hi! Let's discuss how we can help bring your vision to life."
        className="pb-8 md:pb-10"
        maxWidth="max-w-6xl"
      />

      <section className="px-4 md:px-8 pb-20">
        <div className="max-w-6xl mx-auto">

          <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
            {/* Contact Form */}
            <div className="bg-white/10 backdrop-blur-sm p-8 md:p-10 rounded-2xl shadow-xl border border-white/20">
              <h2 
                className="text-lg md:text-xl font-bold mb-6"
                style={{ 
                  fontFamily: "'Poppins', sans-serif",
                  color: '#292929'
                }}
              >
                Send Us a Message
              </h2>
              {submitStatus.message && (
                <div 
                  className={`mb-6 p-4 rounded-lg ${
                    submitStatus.type === 'success' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'
                  }`}
                  style={{ fontFamily: "'Poppins', sans-serif" }}
                >
                  {submitStatus.message}
                </div>
              )}
              <form className="space-y-6" onSubmit={handleContactSubmit}>
                <div>
                  <label 
                    htmlFor="name" 
                    className="block mb-2"
                    style={{ 
                      fontFamily: "'Poppins', sans-serif",
                      color: '#292929',
                      fontSize: '0.95rem'
                    }}
                  >
                    Name *
                  </label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    required
                    className="w-full px-4 py-3 bg-white/80 backdrop-blur-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#ff7a59] focus:border-transparent transition-all duration-300"
                    style={{ fontFamily: "'Poppins', sans-serif", color: '#292929' }}
                    placeholder="Your name"
                  />
                </div>
                <div>
                  <label 
                    htmlFor="email" 
                    className="block mb-2"
                    style={{ 
                      fontFamily: "'Poppins', sans-serif",
                      color: '#292929',
                      fontSize: '0.95rem'
                    }}
                  >
                    Email *
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                    className="w-full px-4 py-3 bg-white/80 backdrop-blur-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#ff7a59] focus:border-transparent transition-all duration-300"
                    style={{ fontFamily: "'Poppins', sans-serif", color: '#292929' }}
                    placeholder="Your email"
                  />
                </div>
                <div>
                  <label 
                    htmlFor="phoneNumber" 
                    className="block mb-2"
                    style={{ 
                      fontFamily: "'Poppins', sans-serif",
                      color: '#292929',
                      fontSize: '0.95rem'
                    }}
                  >
                    Phone (Optional)
                  </label>
                  <input
                    type="tel"
                    id="phoneNumber"
                    name="phoneNumber"
                    value={formData.phoneNumber}
                    onChange={handleInputChange}
                    className="w-full px-4 py-3 bg-white/80 backdrop-blur-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#ff7a59] focus:border-transparent transition-all duration-300"
                    style={{ fontFamily: "'Poppins', sans-serif", color: '#292929' }}
                    placeholder="Your phone number"
                  />
                </div>
                <div>
                  <label 
                    htmlFor="message" 
                    className="block mb-2"
                    style={{ 
                      fontFamily: "'Poppins', sans-serif",
                      color: '#292929',
                      fontSize: '0.95rem'
                    }}
                  >
                    Message *
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleInputChange}
                    rows="4"
                    required
                    className="w-full px-4 py-3 bg-white/80 backdrop-blur-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#ff7a59] focus:border-transparent resize-none transition-all duration-300"
                    style={{ fontFamily: "'Poppins', sans-serif", color: '#292929' }}
                    placeholder="Whats up?!"
                  ></textarea>
                </div>
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="group w-full py-3 backdrop-blur-sm text-white font-medium rounded-full relative overflow-hidden transition-all duration-300 shadow-lg transform hover:scale-105 hover:shadow-xl disabled:opacity-50 disabled:cursor-not-allowed"
                  style={{ 
                    backgroundColor: '#ff7a59',
                    fontFamily: "'Poppins', sans-serif",
                    fontSize: '0.95rem'
                  }}
                >
                  <span className="relative z-10">
                    {isSubmitting ? 'SENDING...' : 'SEND MESSAGE'}
                  </span>
                  <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-1000"></div>
                </button>
              </form>
            </div>

            {/* Contact Information */}
            <div className="bg-white/10 backdrop-blur-sm p-8 md:p-10 rounded-2xl shadow-xl border border-white/20">
              <h2 
                className="text-lg md:text-xl font-bold mb-8"
                style={{ 
                  fontFamily: "'Poppins', sans-serif",
                  color: '#292929'
                }}
              >
                Get in Touch
              </h2>
              <div className="space-y-6">
                <div className="flex items-start space-x-4">
                  <div className="p-3 rounded-lg relative z-10" style={{ backgroundColor: 'rgba(255, 122, 89, 0.35)' }}>
                    <FaEnvelope className="w-5 h-5" style={{ color: '#292929' }} />
                  </div>
                  <div>
                    <h3 
                      className="text-base font-bold mb-2"
                      style={{ 
                        fontFamily: "'Poppins', sans-serif",
                        color: '#292929'
                      }}
                    >
                      Email
                    </h3>
                    <a 
                      href="mailto:zarafairooz@webanova.studio" 
                      className="transition-colors hover:opacity-70 text-sm md:text-base"
                      style={{ 
                        fontFamily: "'Poppins', sans-serif",
                        color: '#292929'
                      }}
                    >
                      zarafairooz@webanova.studio
                    </a>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="p-3 rounded-lg relative z-10" style={{ backgroundColor: 'rgba(255, 122, 89, 0.35)' }}>
                    <FaPhone className="w-5 h-5" style={{ color: '#292929' }} />
                  </div>
                  <div>
                    <h3 
                      className="text-base font-bold mb-2"
                      style={{ 
                        fontFamily: "'Poppins', sans-serif",
                        color: '#292929'
                      }}
                    >
                      Phone
                    </h3>
                    <a 
                      href="tel:8186419709" 
                      className="transition-colors hover:opacity-70 text-sm md:text-base"
                      style={{ 
                        fontFamily: "'Poppins', sans-serif",
                        color: '#292929'
                      }}
                    >
                      (818) 641-9709
                    </a>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="p-3 rounded-lg relative z-10" style={{ backgroundColor: 'rgba(255, 122, 89, 0.35)' }}>
                    <FaMapMarkerAlt className="w-5 h-5" style={{ color: '#292929' }} />
                  </div>
                  <div>
                    <h3 
                      className="text-base font-bold mb-2"
                      style={{ 
                        fontFamily: "'Poppins', sans-serif",
                        color: '#292929'
                      }}
                    >
                      Location
                    </h3>
                    <p 
                      className="text-sm md:text-base"
                      style={{ 
                        fontFamily: "'Poppins', sans-serif",
                        color: '#292929'
                      }}
                    >
                      Los Angeles, CA
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </PageLayout>
  );
} 